<template>
    <rkm-area
        :closed="closed"
        background-color="primary"
        title="Marcadores de consumo alimentar"
        type="box"
    >
        <rkm-form>
            <rkm-area
                :title="data.form.marcadorConsumoAlimentar.titulo"
                type="fieldset"
            >
                <FormQuestionario
                    v-if="data.form.marcadorConsumoAlimentar.perguntas.length >= 1"
                    :questionario="questionario"
                    :required="false"
                    :titulo="data.form.marcadorConsumoAlimentar.tituloArea"
                    ref="FormQuestionario"
                />
            </rkm-area>
        </rkm-form>
    </rkm-area>
</template>

<script>
// Components
import FormQuestionario from '@/components/atencao-basica/marcador-consumo-alimentar/components/questionario/Form.vue'

export default {
    components: {FormQuestionario},
    computed: {
        questionario() {
            const questionario = this.data.form.marcadorConsumoAlimentar.perguntas

            if (this.data.model.marcadorConsumoAlimentar.perguntas && this.data.model.marcadorConsumoAlimentar.perguntas.length > 0) {
                questionario.respostasMarcadas = this.data.model.marcadorConsumoAlimentar.perguntas
            }

            return questionario
        },
    },
    mounted() {
        this.$watch(
            () => this.$refs.FormQuestionario.model,
            {
                deep: true,
                handler(value) {
                    this.data.model.marcadorConsumoAlimentar = value
                }
            }
        )
    },
    props: {
        closed: {type: Boolean, default: false},
        data: {type: Object, required: true},
    },
}
</script>